import { cn } from "@win-reality/react-ui";

type InningHalfIconProps = {
  isTopInning: boolean;
  className?: string;
};

/** Rounded triangle: points up for top of inning, down for bottom. */
export const InningHalfIcon = ({
  isTopInning,
  className,
}: InningHalfIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="12"
    viewBox="0 0 15 13"
    fill="none"
    aria-hidden="true"
    className={cn("shrink-0 text-gray-900 dark:text-white", className)}
    style={isTopInning ? undefined : { transform: "rotate(180deg)" }}
  >
    <path
      d="M5.45814 1C6.22794 -0.333333 8.15245 -0.333333 8.92225 1L14.1097 9.985C14.8795 11.3183 13.9173 12.985 12.3777 12.985H2.0027C0.463104 12.985 -0.499148 11.3183 0.270653 9.985L5.45814 1Z"
      fill="currentColor"
    />
  </svg>
);
